// Each theme maps onto the CSS variables used throughout editor.css.
// bg/ink/dim/chrome/line are the surface; the rest drive syntax colours.
export const THEMES = [
    {
        name: 'ember',
        description: 'Charcoal, amber and warm paper',
        vars: {
            bg: '#0b0b0c', ink: '#dcd6cc', dim: '#78736c', chrome: '#a29d95', line: '#171618',
            accent: '#f2a93b', kw: '#e07a5f', fn: '#7fa7d9', str: '#efe7d6', ty: '#6fb7a8', num: '#c99cf0',
        },
    },
    {
        name: 'orchid',
        description: 'Basalt, hot pink and ultraviolet',
        vars: {
            bg: '#0d0b10', ink: '#ddd4e1', dim: '#7c7286', chrome: '#a59bac', line: '#19151d',
            accent: '#ff5ca8', kw: '#b48cff', fn: '#6f8dff', str: '#f4eff6', ty: '#5ccad8', num: '#ff9d66',
        },
    },
    {
        name: 'verdant',
        description: 'Deep forest, mint and moss',
        vars: {
            bg: '#0a0f0c', ink: '#d2dbcf', dim: '#6d7c71', chrome: '#99a69c', line: '#121a15',
            accent: '#6be39d', kw: '#a3cf6a', fn: '#78d0c0', str: '#eef2e7', ty: '#8db9a8', num: '#e8c27a',
        },
    },
    {
        name: 'tide',
        description: 'Midnight navy and electric cyan',
        vars: {
            bg: '#071016', ink: '#cfdde6', dim: '#5e7583', chrome: '#8ea4b1', line: '#0f1c24',
            accent: '#38bdf8', kw: '#82d4fb', fn: '#a6b3fb', str: '#e6f1f7', ty: '#67e6f6', num: '#f6a6d1',
        },
    },
    {
        name: 'paper',
        description: 'Warm daylight and ink',
        light: true,
        vars: {
            bg: '#f3f0e9', ink: '#2a2723', dim: '#8a847b', chrome: '#5c574f', line: '#e7e2d7',
            accent: '#c2410c', kw: '#7c3aed', fn: '#1d4ed8', str: '#3f3a33', ty: '#0f766e', num: '#b45309',
        },
    },
];

const STORAGE_KEY = 'adeboye.theme';

export function loadThemeName() {
    try {
        const saved = localStorage.getItem(STORAGE_KEY);
        if (THEMES.some((t) => t.name === saved)) return saved;
    } catch (e) {
        // storage unavailable (private mode etc.) — fall back to the default
    }
    return THEMES[0].name;
}

export function saveThemeName(name) {
    try {
        localStorage.setItem(STORAGE_KEY, name);
    } catch (e) {
        // ignore
    }
}

export function findTheme(name) {
    return THEMES.find((t) => t.name === name) || THEMES[0];
}

export function nextTheme(name) {
    const i = THEMES.findIndex((t) => t.name === name);
    return THEMES[(i + 1) % THEMES.length];
}

export function applyTheme(theme) {
    const root = document.documentElement;
    Object.entries(theme.vars).forEach(([k, v]) => root.style.setProperty(`--${k}`, v));
    root.style.colorScheme = theme.light ? 'light' : 'dark';
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute('content', theme.vars.bg);
}
